import React from 'react';
import PropTypes from 'prop-types';
import NameFilter from 'components/form/filters/NameFilter';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';

const PropertiesListFilters = (props) => {
    const filters = {
        basic: {
            name: {
                component: NameFilter,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

PropertiesListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default PropertiesListFilters;



// WEBPACK FOOTER //
// ./src/pages/properties/list/PropertiesListFilters.js